<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-inbox-out">
      Sent Emails
    </PageTitle>

    <v-row>
      <v-col cols="12"
             md="3">
        <v-form @submit.prevent="gotoPage(1)"
                :disabled="form.busy">
          <v-card>
            <v-card-text class="pb-0">

              <v-select v-model="timePeriod"
                        label="Time period"
                        outlined
                        dense
                        :items="timePeriods"
                        item-text="text"
                        return-object
                        @change="selectTimePeriod">
              </v-select>

              <v-text-field v-model="form.start_at"
                            type="date"
                            label="Start date"
                            outlined
                            dense
                            :min="minStartDate"
                            :max="maxStartDate"
                            required
                            :error-messages="form.errors.get('start_at')">
              </v-text-field>

              <v-text-field v-model="form.end_at"
                            type="date"
                            label="End date"
                            outlined
                            dense
                            :min="minEndDate"
                            :max="maxEndDate"
                            required
                            :error-messages="form.errors.get('end_at')">
              </v-text-field>

              <v-text-field v-model="form.recipient"
                            clearable
                            label="To"
                            outlined
                            dense
                            placeholder="Email address contains">
              </v-text-field>

              <v-text-field v-model="form.subject"
                            clearable
                            label="Subject"
                            outlined
                            dense
                            placeholder="Subject contains">
              </v-text-field>

              <v-select v-model="form.status"
                        clearable
                        label="Status"
                        outlined
                        dense
                        :items="statusCodes"
                        item-value="id"
                        item-text="text">
              </v-select>

            </v-card-text>
            <v-card-actions class="px-4 pt-0">
              <v-btn type="submit"
                     :disabled="form.busy"
                     color="primary">
                Search
              </v-btn>
              <v-btn type="reset"
                     :disabled="form.busy"
                     @click.prevent="reset">
                Reset
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

      </v-col>
      <v-col cols="12"
             md="9">
        <v-card>
          <MessagesTable :messages="messages"
                         :loading="form.busy"
                         :form="form"
                         :pagination="pagination"
                         :use-dialog="true"
                         @update:options="updateOptions">
          </MessagesTable>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {find, forOwn} from 'lodash';
import MessagesTable from './components/MessagesTable';
import mailgunService from '../../../../ml/services/mailgunService';
import moment from 'moment-timezone';
import base64url from 'base64-url';
import PageTitle from '../../components/PageTitle.vue';

const fullDateFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DD';

export default {
  components: {PageTitle, MessagesTable},
  data() {
    return {
      activities: mailgunService.activities(),
      events: mailgunService.events(), // MLD-1742
      form: new Form(mailgunService.initMessagesForm(50)),
      messages: [],
      pagination: {
        total: 0,
        count: 0,
        current_page: 1,
        total_pages: 1,
        links: {},
      },
      statusCodes: mailgunService.getStatusCodes(), // MLD-6106
      tags: [],
      today: moment().endOf('day'),
      testTypes: [
        {id: '', name: 'Both'},
        {id: 'real', name: 'Real'},
        {id: 'test', name: 'Test'},
      ],
      timePeriod: 'Past 30 days',
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'team',
      'user',
      'users',
    ]),
    timePeriods() { // MLD-6154
      return mailgunService.timePeriods();
    },
    startAtUTC() {
      try {
        return moment(this.form.start_at).tz('UTC').startOf('minute').format(fullDateFormat);
      } catch (e) {
        return '';
      }
    },
    endAtUTC() {
      try {
        return moment(this.form.end_at).tz('UTC').endOf('minute').format(fullDateFormat);
      } catch (e) {
        return '';
      }
    },
    minStartDate() {
      if (this.team) {
        return moment(this.team.created_at).format('YYYY-MM-DD');
      }
      return null;
    },
    maxStartDate() {
      return this.today.format('YYYY-MM-DD');
    },
    minEndDate() {
      return this.form.start_at;
    },
    maxEndDate() {
      return this.today.format('YYYY-MM-DD');
    },
  },
  created() {
    this.initFromQuery();
    this.search();
  },
  methods: {
    initFromQuery() {
      try {
        const q = this.$route.query.q;
        if (q) {
          const query = JSON.parse(base64url.decode(q));
          //console.log('initFromQuery', query);
          forOwn(query, (value, key) => {
            if (this.form.hasOwnProperty(key)) {
              this.form[key] = value;
            }
          })
        }
      } catch (e) {
      }
    },
    async search() {
      if (this.form.busy) {
        return;
      }
      if (false === this.$root.isAdminRoute) {
        this.form.sender_id = this.user.id;
      }
      this.form.startProcessing();

      const query = {
        ...this.form.data(),
      }
      const encodedQuery = base64url.encode(JSON.stringify(query));
      const nonce = Date.now().toString();
      await this.$router.push({name: this.$route.name, query: {q: encodedQuery, nonce: nonce}})

      return Promise.all([
        this.getTags(),
        this.getMessages(),
      ])
        .catch(err => {
          //this.$toast.error('An error occurred.');
        })
        .finally(() => {
          this.form.busy = false;
          this.form.export = false;
        })
    },
    getMessages() {
      const form = this.form.data();
      form.start_at = this.startAtUTC;
      form.end_at = this.endAtUTC;
      return mailgunService.getMessages(form)
        .then(data => {
          if (data && data.data && data.meta) {
            this.messages = data.data;
            this.pagination = data.meta.pagination;
          }
          return data;
        })
        .catch(err => {
          this.form.handleErrors(err);
          throw err;
        })
    },
    getTags() {
      return mailgunService.tags()
        .then(data => {
          this.tags = data;
          return data;
        })
    },
    gotoPage(page) {
      if (this.pagination && page > 0 && page <= this.pagination.total_pages) {
        this.form.page = page;
      } else {
        this.form.page = 1;
      }
      this.search();
    },
    reset() {
      this.form.reset();
      this.search();
    },
    updateOptions(options) {
      //console.log('updateOptions', options);
      this.form.per_page = options.itemsPerPage;
      this.gotoPage(options.page);
    },
    selectTimePeriod() {
      if (this.timePeriod) {
        this.changeTimePeriod(this.timePeriod);
      } else {
        this.resetForm();
      }
    },
    resetForm() {
      this.timePeriod = find(this.timePeriods, t => t.text === this.defaultTimePeriod);
      this.form = new Form(mailgunService.initMessagesForm(this.defaultPerPage));
      this.changeTimePeriod(this.timePeriod);
    },
    changeTimePeriod(timePeriod) {
      if (this.form.busy) {
        this.$toast.warning('Busy - please wait');
        return;
      }
      const startPeriod = timePeriod.start;
      const endPeriod = timePeriod.end;
      const start = moment().add(startPeriod.units, startPeriod.period).startOf(startPeriod.period);
      const end = moment().add(endPeriod.units, endPeriod.period).endOf(endPeriod.period);
      this.form.start_at = start.format(dateFormat);
      this.form.end_at = end.format(dateFormat);
      this.search();
    },
  }
}
</script>
